<template>
  <b-modal  scrollable v-model="show" centered :title="'Auftragsgruppe wählen'">
    <b-row>
      <b-col md="4">
        <b-form-input type="search" v-model="search" placeholder="Suchen" debounce="200" style="margin-bottom: 6px"></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table ref="augr_table" :items="remainingAugrs"
                 striped hover selectable
                 :fields="fields"
                 :sort-by="sortBy"
                 :sort-desc="sortDesc"
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelected">
          <template #table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                style="min-width: 100px"
            >
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" :disabled="!canContinue" @click="onSave">
        Weiter
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "SelectAugrDialog",
  props:{
    augrs: {
      type: Array,
      default: () => []
    },
    selectedAugr: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      search: '',
      sortBy: 'name',
      sortDesc: false,
      show: false,
      selected: [],
      fields: [
        {key: "gischl", label: 'Nummer', sortable: true},
        {key: "name", label: 'Name', sortable: true},
      ],

    }
  },
  computed: {
    canContinue() {
      return this.selected.length > 0;
    },
    remainingAugrs: function () {
      let res = [];
      const filterText = this.search.trim().toLowerCase();
      if (filterText === "") {
        return this.augrs;
      }
      for (let i = 0; i < this.augrs.length; i++) {
        if (
            this.aufns[i].name.toLowerCase().indexOf(filterText) > -1 ||
            this.aufns[i].gischl.toLowerCase().indexOf(filterText) > -1
        ) {
          res.push(this.augrs[i]);
        }
      }
      return res;
    }
  },
  methods: {
    rowSelected(items) {
      console.log(items)
      if (items.length === 0) {
        this.selected = [];
      } else {
        this.selected = items;
      }
    },
    onSave() {
      this.show = false;
      this.$emit("select-augr", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.selected = [];
      this.search = '';
      this.show = true;
      console.log(this.selectedAugr)
      console.log(this.augrs)
      console.log(this.remainingAugrs)

      if (this.selectedAugr !== '') {
        for (let i = 0; i < this.augrs.length; i++) {
          if (this.augrs[i].gischl === this.selectedAugr) {
            this.$nextTick(() => {
              this.$refs.augr_table.selectRow(i);
              console.log(this.augrs[i])
              console.log(i)
              console.log(this.remainingAugrs)
            });
          }
        }
      }

    },
    getReturnData: function () {
      return this.selected[0];
    },
  }
}
</script>

<style scoped>
</style>
